import { render, staticRenderFns } from "./ManageCertificates.vue?vue&type=template&id=084b83f4"
import script from "./ManageCertificates.vue?vue&type=script&lang=js"
export * from "./ManageCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports